<div>
  <tmo-digital-dynamic-modal
    *ngIf="localAemContent"
    pdlPageComponentId="customer-authentication-dynamic-modal"
    [displayModal]="displayModal"
    [aemContent]="aemContent"
    [modal]="modal"
    [style]="digitalAuth"
    (onHide)="closeCustomerAuthenticationModal()"
  >
    <ng-container>
      <div class="row">
        <div class="col-4 xs-hidden img-content pe-0">
          <img alt="brand logo" src="{{ localAemContent?.cobrandedLogos }}" />
        </div>
        <div class="col-md-8 col-12-xs ps-0">
          <ng-container header>
            <div *ngIf="!disableClose" class="modal-logo-close">
              <a
                id="close-x"
                href="javascript:void(0)"
                aria-label="Close"
                class="digital-close-modal pull-right close"
                (click)="closeCustomerAuthenticationModal(true)"
              >
                <i class="fa fa-times-circle"></i>
              </a>
            </div>
          </ng-container>
          <div class="body-content p-t-xl">
            <div class="row">
              <div class="col-12">
                <h2>{{ localAemContent?.welcome }}</h2>
                <p class="mb-4 mt-1">{{ localAemContent?.authSubTitle }}</p>
                <p>
                  <strong>{{ localAemContent?.pleaseNote }}</strong
                  >{{ localAemContent?.authDescription }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="button-box col-12 mt-4">
                <button
                  id="existing-customer-button"
                  class="btn btn-primary rounded-0 w-100 continue-button"
                  (click)="closeExistingCustomerModal()"
                >
                  {{ localAemContent?.iAmExistingCustomer }}
                </button>
              </div>
              <div class="button-box col-12 mt-1 m-b-lg">
                <button
                  id="new-customer-button"
                  class="btn btn-secondary digital-cancel-button rounded-0 w-100 mt-3"
                  (click)="onNewCustomerSelection(false)"
                >
                  {{ localAemContent?.iAmANewCustomer }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </tmo-digital-dynamic-modal>
</div>
<tmo-spinner [setDelay]="!showSpinner"></tmo-spinner>
